import { Component, OnInit } from '@angular/core';
import * as QRCode from 'qrcode';
import { RouteService } from '../shared/route.service';
import { TokenService } from './token.service';
import { MotorTranspModel } from '../shared/models/motorTranspModel';
import { NotificationService } from '../shared/notification.service';
import { DashboardService } from '../dashboard/dashboard.service';
import { ObjectParam, TranspToken } from '../shared/interface/generic-interface';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
declare let jsPDF;
@Component({
    selector: 'popup-tokens',
    templateUrl: './popup-tokens.component.html',
    styleUrls: ['./popup-tokens.component.css'],
    standalone: true,
    imports: [NgIf, FormsModule, NgFor, DatePipe]
})
export class PopupTokensComponent implements OnInit {
  qrCodeBase64: string;
  tokens: TranspToken[] = [];
  transportadoras: MotorTranspModel[] = [];
  loading = false;
  inputDescricao = '';
  inputDescricaoEdicao: String = '';
  cnpj = '';
  switchAtivo = true;
  validade: string;
  validadeEdicao: string;
  switchAtivoEdicao =  false;
  motorTranspSelecionado?: MotorTranspModel
  versaoAtualApp = '';
  urlDownload = '';
  urlPortalTransportadora = 'https://rotaplan.paineltarget.com.br/PortalTransportadora/'
  comValidade = false;

  constructor(
    private dashboardService: DashboardService,
    private routeService: RouteService,
    private tokenService: TokenService,
    private notificationService: NotificationService
  ) { }

  async ngOnInit()  {
    this.loading = true;    
    await this.carregarTransp();
    await this.carregarTokens();
    const dataAtual = new Date();
    dataAtual.setDate(dataAtual.getDate() + 3);
    this.validade = this.formatarData(dataAtual);
    this.loading = false;
    this.desabilitaModoEdicao();
  }

  async carregarTokens() {    
    this.cnpj = await this.tokenService.getEmpresas();
    this.tokens = await this.tokenService.getTokens();  
  }

  async carregarTransp() {    
    this.transportadoras = await this.tokenService.getTransportadoras(); 
  }

  async gerarChave(){

    let contemChaveTranspSelecionada = this.tokens.some((token) => token.motorID == this.motorTranspSelecionado.MotorID);
    if(contemChaveTranspSelecionada){
      this.mostrarAvisoTransportadora();
    }else{
       this.loading = true;
        let objParam: ObjectParam = {
          transpToken: {
           descricao: this.inputDescricao, 
           ativo: this.switchAtivo, 
           validade: this.comValidade ? this.validade : '2900-01-01', 
           cnpj: this.cnpj,
           motorID: this.motorTranspSelecionado.MotorID
          }
        }

        let response = await this.tokenService.geraToken(objParam) 
        if(response.length > 0){
          this.carregarTokens();
          this.inputDescricao = '';
        }

        this.loading = false;
    }
  }

  private formatarData(data: Date): string {
    const dia = data.getDate().toString().padStart(2, '0');
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const ano = data.getFullYear();
    return `${ano}-${mes}-${dia}`;
  }

  editarChave(dados: TranspToken){
    this.desabilitaModoEdicao();
    dados.modoEdicao = true;
    this.validadeEdicao = this.formatarData(new Date(dados.validade.toString()));
    this.inputDescricaoEdicao = dados.descricao;
    this.switchAtivoEdicao = dados.ativo;
  }


  async gravarEdicao(token: TranspToken){
    this.loading = true;
    this.desabilitaModoEdicao();
    token.ativo = this.switchAtivoEdicao;
    token.validade = this.validadeEdicao;
    token.descricao = this.inputDescricaoEdicao;
    let objParam: ObjectParam = {
      transpToken : token
    }
    await this.tokenService.atualizaToken(objParam);
    this.loading = false;

  }

  fecharEdicao(){
    this.desabilitaModoEdicao();
  }

  mostrarAvisoTransportadora() {
    const mensagem = `Já existe um token para a transportadora ${this.motorTranspSelecionado.CdMotor}`;
    this.notificationService.showInformativo(mensagem);
  }

  desabilitaModoEdicao(){
    this.tokens.forEach((token) => token.modoEdicao= false)
  }

  gerarPDFQRCode(dados) {
 
    let indiceY = 10;
    let doc = new jsPDF('l', 'mm', [297, 260]);
    doc.setFontSize(12);
    const qrCodeData = dados.token;
    let text = this.routeService.nomeCliente != ''?  this.routeService.nomeCliente : '';
  
    doc.text(5, indiceY, this.getDataAtualFormatada());   


    indiceY += 10;
    doc.setFontSize(24);
    doc.setFontType("bold");
    let textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    let textX = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(textX, indiceY, text);   
    
    doc.setFontSize(14);
    doc.setFontType("normal");

    indiceY += 10;
    text = 'QR CODE TOKEN - Acesso ao aplicativo'
    textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    textX = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(textX, indiceY, text);  

    indiceY += 7;
    text = 'Utilize a chave de acesso para liberar a utilização do seu aplicativo Rotaplan Transportadora'
    textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    textX = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(textX, indiceY, text);

  
    QRCode.toDataURL(qrCodeData, (err, url) => {
      if (err) {
        console.error('Erro ao gerar o QR Code:', err);
        return;
      }
  
      this.qrCodeBase64 = url.split(',')[1];
      var imgData = 'data:image/png;base64,' + this.qrCodeBase64;

      const qrCodeWidth = 120;
      const qrCodeHeight = 120;
      const qrCodeX = (doc.internal.pageSize.width - qrCodeWidth) / 2;
      const qrCodeY = 40
  
      doc.addImage(imgData, 'png', qrCodeX, qrCodeY, qrCodeWidth, qrCodeHeight);  


      indiceY += 130;
      text = dados.descricao;
      textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
      textX = (doc.internal.pageSize.width - textWidth) / 2;
      doc.text(textX, indiceY, text);

      doc.setFontSize(24);
      doc.setFontType("bold");

      indiceY += 15;
      text = qrCodeData;
      textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
      textX = (doc.internal.pageSize.width - textWidth) / 2;
      doc.text(textX, indiceY, text);
  
     
      doc.setFontSize(14);
      doc.setFontType("normal");

      indiceY += 30;
      text = 'A chave de acesso é uma informação sensível, sendo da responsabilidade da transportadora mantê-la em segurança';
      textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
      textX = (doc.internal.pageSize.width - textWidth) / 2;
      doc.text(textX, indiceY, text);

      indiceY += 7;
      text = 'e em caso de violação informar a distribuidora para sua desativação e renovação';
      textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
      textX = (doc.internal.pageSize.width - textWidth) / 2;
      doc.text(textX, indiceY, text);

      indiceY += 35;
      doc.text(5, indiceY, 'Target Sistemas - Rotaplan Distribuidora');
  
      doc.save('token'+ qrCodeData + ".pdf");
    });
  }
  

  getDataAtualFormatada() {
    const dataAtual = new Date();
  
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const ano = dataAtual.getFullYear();
  
    const dataFormatada = `${dia}/${mes}/${ano}`;
    return dataFormatada;
  } 
  
  copyToClipboard() {
    navigator.clipboard.writeText(this.urlPortalTransportadora).then(() => {
      this.notificationService.showInformativo('Texto copiado para a área de transferência')
    }).catch((error) => {
      console.error('Erro ao copiar para a área de transferência: ', error);
    });
  }

  abrirMapaTransportadora(){
    const urlAtual = window.location.href;  
    const urlTransportadora = urlAtual.replace( 'RadarMotoristaNew', 'RadarTransportadora' );   
    window.open(urlTransportadora, '_blank');
  }
}
